import { useContext } from "react";

import { ThemeContext } from "./ThemeContext";

/**
 * Read and change the active theme.
 *
 * @returns {{
 *   theme: "light" | "dark",              // what the user picked
 *   resolvedTheme: "light" | "dark",      // what is actually on screen
 *   isDark: boolean,
 *   setTheme: (theme: string) => void,
 *   toggleTheme: () => void,
 *   isFallback: boolean                   // true when no provider is mounted
 * }}
 *
 * Nearly all styling should come from the tokens in root.scss/theme.scss rather
 * than from this hook — reach for it only where a colour genuinely can't be
 * expressed in CSS, such as a prop handed to a charting library.
 */
const useTheme = () => useContext(ThemeContext);

export default useTheme;
